<template>
  <div class="min-h-full flex">
    <div class="flex-1 flex flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
      <div class="mx-auto w-full max-w-sm lg:w-96">
        <div>
          <img class="h-12 w-auto" src="/images/studio.svg" alt="St. Audio Studio" />
          <h2 class="mt-6 text-3xl font-extrabold text-gray-900">
            Öffne dein Studio
          </h2>
          <p class="mt-2 text-sm text-gray-600">
            <router-link :to="{name: 'setup'}" class="font-medium text-teal-600 hover:text-teal-500">
              Noch keinen St. Audio Account?
            </router-link>
          </p>
        </div>
        <div v-if="message" class="mt-8 bg-red-50 border-l-4 border-red-400 p-4">
          <p class="text-sm text-red-800" v-html="message" />
        </div>
        <div class="mt-8">
          <div class="mt-6">
            <div class="space-y-6">
              <LoginForm :resource="payload" :errors="errors" />
              <SubmitButton @click="onSubmit" :load="loading">
                Einloggen
              </SubmitButton>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hidden lg:block relative w-0 flex-1">
      <img class="absolute inset-0 h-full w-full object-cover" src="/images/login-3.png" alt="" />
    </div>
  </div>
</template>


<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

const store = useStore();
const router = useRouter();

const action = 'auth/login';
const payload = ref({email: '', password: ''});
const loading = ref(false);
const message = ref('');
const errors = ref({});

const onSuccess = (result) =>
{
  loading.value = false;
  errors.value = new Object;
  message.value = new String;
  router.push({name: 'dashboard'});
};

const onFailure = (error) =>
{
  loading.value = false;
  errors.value = (error?.errors) ?? [];
  message.value = (error?.message) ?? null;
};

const onSubmit = () =>
{
  loading.value = true;
  store.dispatch(action, payload.value)
  .then(result => onSuccess(result))
  .catch(error => onFailure(error));
};
</script>
